import * as v from 'valibot';

export const priceSchema = v.pipe(
  v.array(v.unknown()),
  v.check((value) => {
    const [min, max] = (value as unknown[]) || [];
    if (typeof min === 'number' && typeof max === 'number') {
      return min <= max;
    }
    return true;
  }, 'invalid-range')
);
